import screen from './Main';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Gifts/Edit/index.js